import { useEffect, useState } from "react";
import {
  DataGrid,
  Loading,
  Step,
  StepLabel,
  Stepper,
} from "../../../../../components";
import { notification, PessoaService } from "../../../../../services";
import { formatCelular, responseErros } from "../../../../../utils";
import { MensagemPersonalizadaForm } from "../form/mensagem-personalizada-form.component";
import { FiltrosPessoasMensagemLote } from "../filtros/filtros-pessoas-mensagem-lote.component";

export function MensagemLoteStepper({
  id,
  mensagem,
  handleChange,
  handleOpenEmojiPicker,
  handleEmojiSelect,
  inserirVariavel,
  emojiAnchorEl,
  inputErros,
  activeStep,
  setActiveStep,
  msgLote,
  listaDadosPessoas,
  setListaDadosPessoas,
  imageAnexo,
  setImageAnexo,
  filtros,
  setFiltros,
  steps,
  setSteps,
  pessoasSelecionadas,
  setPessoasSelecionadas,
}) {
  const [loading, setLoading] = useState(false);

  const [rowCount, setRowCount] = useState(null);
  const pessoaService = new PessoaService();
  const colunas = [
    {
      field: "nomeRazaoSocial",
      headerName: "Nome",
      flex: 700,
      filtrar: true,
      valueGetter: (params) =>
        params.row.nomeRazaoSocial || params.row.nome_razao_social,
    },
    {
      field: "celular",
      headerName: "Celular",
      flex: 300,
      valueGetter: (params) => formatCelular(params.value),
    },
  ];

  const baseSteps = [
    "Selecione Filtros Clientes",
    ...(filtros?.todosClientes ? [] : ["Visualize Clientes"]),
    "Selecione ou Cadastre mensagem",
  ];

  useEffect(() => {
    setSteps(baseSteps);
    if (activeStep === 1 && !filtros?.todosClientes) {
      buscaDadosPessoasRelatorio();
    }
    if (activeStep === 0) {
      setPessoasSelecionadas([]);
    }
  }, [activeStep, filtros?.todosClientes]);

  const buscaDadosPessoasRelatorio = async (filter) => {
    setLoading(true);
    if (filtros?.tagsId?.length) {
      filtros.tagsId = filtros.tagsId.map(({ id }) => id);
    }
    const result = await pessoaService.relatorioDadosPessoa({
      ...filter,
      ...filtros,
    });
    if (!result.isAxiosError) {
      if (!result.data.rows.length) {
        setLoading(false);
        setActiveStep(0);
        setFiltros(null);
        return notification.alertaGenericos(
          `Não há pessoas ${alertaContexto()} para o filtro selecionado`
        );
      }
      setListaDadosPessoas(result.data.rows);
      setRowCount(result.data.count);
    } else {
      responseErros(result);
    }
    setLoading(false);
  };

  const sendServerDatagrid = (props) => {
    if (props.tipoFiltro == "simples") {
      buscaDadosPessoasRelatorio(props.filtros);
    }
  };

  const handleSelectionChange = (selection) => {
    const currentPageIds = listaDadosPessoas.map((row) => row.id);

    setPessoasSelecionadas((prev) => {
      const others = prev.filter((id) => !currentPageIds.includes(id));
      return [...others, ...selection];
    });
  };

  function alertaContexto() {
    switch (mensagem?.contexto) {
      case "aniversario":
        return "aniversariando";
      case "condicional-cobranca":
        return "com condicionais em débito";
      case "condicional-lembrete":
        return "com condicionais a vencer";
      case "conta-receber-cobranca":
        return "com contas a receber em débito";
      case "conta-receber-lembrete":
        return "com contas receber a vencer";
      default:
        return "";
    }
  }

  function content() {
    if (filtros?.todosClientes) {
      if (activeStep === 0) {
        return (
          <FiltrosPessoasMensagemLote
            id={id}
            mensagem={mensagem}
            filtros={filtros}
            activeStep={activeStep}
            setFiltros={setFiltros}
            inputErros={inputErros}
            handleChange={handleChange}
          />
        );
      }
      return (
        <MensagemPersonalizadaForm
          id={id}
          mensagem={mensagem}
          handleChange={handleChange}
          handleOpenEmojiPicker={handleOpenEmojiPicker}
          handleEmojiSelect={handleEmojiSelect}
          inserirVariavel={inserirVariavel}
          emojiAnchorEl={emojiAnchorEl}
          inputErros={inputErros}
          msgLote={msgLote}
          imageAnexo={imageAnexo}
          setImageAnexo={setImageAnexo}
        />
      );
    }

    switch (activeStep) {
      case 1:
        return (
          <div className="p-2">
            <DataGrid
              checkboxSelection
              rows={listaDadosPessoas}
              columns={colunas}
              rowCount={rowCount}
              paginationMode="server"
              sendServer={sendServerDatagrid}
              onRowSelectionModelChange={handleSelectionChange}
              selectionModel={pessoasSelecionadas}
              disableAcoes
              noFilter
            />
            <Loading loading={loading} />
          </div>
        );
      case 2:
        return (
          <MensagemPersonalizadaForm
            id={id}
            mensagem={mensagem}
            handleChange={handleChange}
            handleOpenEmojiPicker={handleOpenEmojiPicker}
            handleEmojiSelect={handleEmojiSelect}
            inserirVariavel={inserirVariavel}
            emojiAnchorEl={emojiAnchorEl}
            inputErros={inputErros}
            msgLote={msgLote}
            imageAnexo={imageAnexo}
            setImageAnexo={setImageAnexo}
          />
        );
      default:
        return (
          <FiltrosPessoasMensagemLote
            id={id}
            mensagem={mensagem}
            filtros={filtros}
            activeStep={activeStep}
            setFiltros={setFiltros}
            inputErros={inputErros}
            handleChange={handleChange}
          />
        );
    }
  }

  return (
    <>
      <div className="p-3 mb-2">
        <Stepper activeStep={activeStep}>
          {steps.map((titulo) => (
            <Step key={titulo}>
              <StepLabel>{titulo}</StepLabel>
            </Step>
          ))}
        </Stepper>
      </div>
      {content()}
    </>
  );
}
